(function () {
  'use strict';

  var routes = window.MOOD_ROUTES || {};
  if (!routes.root) return;

  var exact = {
    '/products/mood-energy': routes.energy,
    '/products/mood-relax': routes.relax,
    '/products/mood-sleep': routes.sleep,
    '/products/mood-full-day': routes.fullDay,
    '/pages/club': routes.club,
    '/pages/policies': routes.policies,
    '/blogs/news': routes.journal,
    '/cart': routes.cart,
    '/search': routes.search,
    '/checkout': routes.checkout
  };

  function withHash(target, hash) {
    return target ? target + (hash || '') : '';
  }

  function normalize(value) {
    if (!value || value.charAt(0) !== '/' || value.indexOf('//') === 0) return value;
    var parsed;
    try { parsed = new URL(value, window.location.origin); } catch (error) { return value; }
    if (exact[parsed.pathname]) return withHash(exact[parsed.pathname], parsed.hash);
    if (parsed.pathname === '/') return withHash(routes.root, parsed.hash);
    if (parsed.pathname.indexOf('/blogs/news/') === 0 && routes.journal) {
      return routes.journal.replace(/\/$/, '') + parsed.pathname.slice('/blogs/news'.length) + parsed.search + parsed.hash;
    }
    if (parsed.pathname === '/contact' && routes.root) {
      return routes.root.replace(/\/$/, '') + '/contact' + parsed.search + parsed.hash;
    }
    return value;
  }

  document.querySelectorAll('a[href^="/"],form[action^="/"]').forEach(function (node) {
    var attribute = node.tagName === 'FORM' ? 'action' : 'href';
    var current = node.getAttribute(attribute);
    var resolved = normalize(current);
    if (resolved && resolved !== current) node.setAttribute(attribute, resolved);
  });
  document.documentElement.dataset.moodRoutes = 'v67';
})();
